import(/* webpackChunkName: "semantic-theme" */"@semantic-theme").then(()=>{});
import React from 'react'
import { Label, Icon, Loader } from 'semantic-ui-react'
import styled from 'styled-components';
import { darken } from 'polished'

const alignments = {
  'topLeft': 'gfy-top-left',
  'topRight': 'gfy-top-right',
  'bottomLeft': 'gfy-bottom-left',
  'bottomRight': 'gfy-bottom-right',
};

const StickyContainer = styled.div`
  top: 23px;
  padding-top: 0;
  bottom: auto;
  z-index: 9999;
  position: fixed;
  right: 23px;
  
  &.gfy-top-left {
    top: 23px;
    left: 23px;
    bottom: auto;
    right: auto;
  }
  
  &.gfy-top-right {
    top: 23px;
    left: auto;
    bottom: auto;
    right: 23px;
  }
  
  &.gfy-bottom-right {
    top: auto;
    left: auto;
    bottom: 23px;
    right: 23px;
  }
  
  &.gfy-bottom-left {
    top: auto;
    left: 23px;
    bottom: 23px;
    right: auto;
  }
  
  .label {
    height: auto !important;
    position: static !important;
    top: auto !important;
    right: auto !important;
  }
`;

const ButtonContainer = styled.div`
  background: ${props => (props.inverted ? props.theme.primary : '#FFFFFF')};
  box-shadow: 0 1px 3px 0 rgba(0,0,0,0.05), 0 16px 32px 0 rgba(0,0,0,0.10);
  border-radius: 4px;
  cursor: pointer;
  padding: 20px;
  
  &:hover {
    background: ${props => props.inverted ? darken(0.05, props.theme.primary) : darken(0.075, '#FFFFFF')};
    i.icon {
      ${props => (props.inverted ? '' : 'color: #000;')}
    }
  }
  
  i.icon {
    margin-right: 16px;
    ${props => (props.inverted ? 'color: #FFF;' : '')}
  }
  
  .active.inline.loader {
    margin-right: 8px;
  }
`;


export default class CartButton extends React.PureComponent {
  static defaultProps = {
    inverted: false,
  };
  handleClick = (e) => {
    const { loading, onClick } = this.props;
    if(!loading) {
      e.preventDefault();
      onClick();
    }
  };

  render() {
    const { onClick, loading, count, inverted, cartButtonAlignment } = this.props;
    const stickyClass = alignments[cartButtonAlignment];
    return (
      <StickyContainer className={stickyClass}>
        <ButtonContainer onClick={ onClick } inverted={ inverted }>
          { loading ? <Loader size='small' active inline inverted={ inverted } /> : <Icon name='cart' /> }
          { count ?
            <Label circular color="green">
              { count }
            </Label>
            : null }
        </ButtonContainer>
      </StickyContainer>
    )
  }
}
